import { executeNetworkAsync } from "../../helper/handler/network";
import { clientAxiosInstance } from "../../types/swrFetcher";

export const resetPassword = async (email: string, currentCountry: string) => {
  const networkCall = async () =>
    await clientAxiosInstance().post("/api/auth/resetPassword", {
      email,
      currentCountry,
    });

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
